import { useQuery } from '@tanstack/react-query';
import skillsService from '../services/skillsService';
import { queryKeys } from './queryKeys';

export function useSkills(options = {}) {
  return useQuery({
    queryKey: queryKeys.skills.all,
    queryFn: () => skillsService.getAllSkills(),
    staleTime: Infinity,
    ...options,
  });
}

export function useSkillDetail(skillId, options = {}) {
  return useQuery({
    queryKey: queryKeys.skills.detail(skillId),
    queryFn: () => skillsService.getSkillDetails(skillId),
    enabled: !!skillId,
    ...options,
  });
}
